export const MENU_PERMISSIONS = [
  {key:"control-room",label:"Control Room",legacy:"sites"},
  {key:"offers",label:"Offerte",legacy:"offers",children:[["list","Elenco offerte"],["computo","Computi"],["ai-engine","AI Project Engine"]]},
  {key:"accounting",label:"Contabilità cantieri",legacy:"accounting",children:[["cme","Computo CME"],["sal","SAL"],["movimenti","DDT / Fatture / Costi"],["payroll","Manodopera"]]},
  {key:"sites",label:"Cantieri",legacy:"sites",children:[["dashboard","Cruscotto"],["tasks","Task"],["fasi","Fasi"],["bimviewer","BIM Viewer"],["gantt","Cronoprogramma"],["attendance","Presenze"],["tools","Tool operativi"],["journal","Giornale lavori"],["emails","Email"],["cme","Computo CME"],["sal","SAL"],["movimenti","DDT / Fatture / Costi"],["payroll","Manodopera"],["offers","Offerte collegate"]]},
  {key:"customers",label:"Clienti",legacy:"sites"},
  {key:"suppliers",label:"Fornitori",legacy:"sites"},
  {key:"tenders",label:"Gare",legacy:"offers"},
  {key:"workers",label:"Operai",legacy:"workers",children:[["registry","Anagrafica"],["attendance","Presenze"]]},
  {key:"contacts",label:"Contatti",legacy:"sites"},
  {key:"emails",label:"Email",legacy:"emails"},
  {key:"whatsapp",label:"WhatsApp",legacy:"admin"},
  {key:"documents",label:"Documenti",legacy:"documents"},
  {key:"pricebooks",label:"Prezzari regionali",legacy:"offers"},
  {key:"settings",label:"Impostazioni",legacy:"admin",children:[["users","Utenti e permessi"],["company","Azienda"],["integrations","Integrazioni"],["ai","AI e consumi"],["field","Field"]]},
];
export const menuKey=(section,sub)=>"menu."+section+(sub?"."+sub:"");
export const canMenu=(user,section,sub)=>{
  if(user?.is_admin)return true;
  const p=user?.permissions||{};
  const item=MENU_PERMISSIONS.find(x=>x.key===section);
  if(!item)return false;
  if(p[menuKey(section)]===false)return false;
  if(sub&&p[menuKey(section,sub)]===false)return false;
  if(p[menuKey(section)]===true)return !sub||p[menuKey(section,sub)]!==false;
  return Boolean(p[item.legacy]);
};

export const permissionChoice = (permissions,key) => permissions?.[key] === true ? "grant" : permissions?.[key] === false ? "deny" : "inherit";
export const withPermissionChoice = (permissions,key,choice) => {
  if (!["inherit","grant","deny"].includes(choice)) throw new Error("Scelta permesso non valida");
  const next={...permissions};
  if (choice === "inherit") delete next[key];
  else next[key]=choice === "grant";
  return next;
};
